module.exports = __webpack_public_path__ + "img/qrcode.9e681d77.jpg";